"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @author [Jonathan Kernick, Lloyd Evans]
 */

/**
 * @param  {number} hexNum
 * @returns {object}
 */
var hexToRgb = exports.hexToRgb = function hexToRgb(hexNum) {
  var rgb = {};
  rgb.r = Math.floor(hexNum / (256 * 256)) % 256;
  rgb.g = Math.floor(hexNum / 256) % 256;
  rgb.b = hexNum % 256;
  return rgb;
};
/**
 * @param  {number} hexNum
 * @returns {string}
 */


var hexToString = exports.hexToString = function hexToString(hexNum) {
  var hexString = hexNum.toString(16);
  hexString = "00000" + hexString;
  hexString = "#" + hexString.substr(-6, 6);
  return hexString;
};
/**
 * @param  {string} stringColour
 * @returns {number}
 */


var stringToHex = exports.stringToHex = function stringToHex(color) {
  return parseInt(color.substr(-6, 6), 16);
};
/**
 * @param  {number} hexNum
 * @returns {object}
 */


var hexToRgbValue = exports.hexToRgbValue = function hexToRgbValue(hexNum) {
  var rgb = hexToRGB(hexNum);
  rgb.r /= 255;
  rgb.g /= 255;
  rgb.b /= 255;
  return rgb;
};
/**
 * @param  {object} rgbObj
 * @returns {number}
 */


var rgbToHex = exports.rgbToHex = function rgbToHex(rgbObj) {
  red = 0x10000 * Math.floor(rgbObj.r);
  green = 0x100 * Math.floor(rgbObj.g);
  blue = Math.floor(rgbObj.b);
  return red + green + blue;
};
/**
 * @param  {object} rgbObj
 * @returns {number}
 */


var rgbValueToHex = exports.rgbValueToHex = function rgbValueToHex(rgbObj) {
  red = 0x10000 * Math.floor(0xff * rgbObj.r);
  green = 0x100 * Math.floor(0xff * rgbObj.g);
  blue = Math.floor(0xff * rgbObj.b);
  return red + green + blue;
};
/**
 * @param  {number} hexA
 * @param  {number} hexB
 * @param  {number} value
 * @returns {number}
 */


var hexLerp = exports.hexLerp = function hexLerp(hexA, hexB, value) {
  var rgbObj = {};
  var rgbA = hexToRGBvalue(hexA);
  var rgbB = hexToRGBvalue(hexB);
  rgbObj.r = (rgbB.r - rgbA.r) * value + rgbA.r;
  rgbObj.g = (rgbB.g - rgbA.g) * value + rgbA.g;
  rgbObj.b = (rgbB.b - rgbA.b) * value + rgbA.b;
  return rgbValueToHex(rgbObj);
};
/**
 * @param  {number} hexA
 * @param  {number} hexB
 * @param  {number} value
 * @returns {number}
 */


var hexSqrLerp = exports.hexSqrLerp = function hexSqrLerp(hexA, hexB, value) {
  var rgb = {};
  var rgbA = hexToRGBvalue(hexA);
  var rgbB = hexToRGBvalue(hexB);
  rgbA.a *= rgbA.r;
  rgbA.g *= rgbA.g;
  rgbA.b *= rgbA.b;
  rgbB.r *= rgbB.r;
  rgbB.g *= rgbB.g;
  rgbB.b *= rgbB.b;
  rgb.r = Math.sqrt((rgbB.r - rgbA.r) * value + rgbA.r);
  rgb.g = Math.sqrt((rgbB.g - rgbA.g) * value + rgbA.g);
  rgb.b = Math.sqrt((rgbB.b - rgbA.b) * value + rgbA.b);
  return rgbValueToHex(rgb);
};